
import {
  redux_getAllPartnerUsers,
  redux_getPartnerUser,
  redux_updatePartnerUser,
  redux_createPartnerUser,
  redux_partnerActionStarts,
  redux_partnerActionErrors,
  redux_resetPartnerErrors,
} from '../../core/data/redux/modules/partner/actions';

import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

export const getAllPartnerUsers = () => async (dispatch: Dispatch) => {
  dispatch(redux_partnerActionStarts());
  try {
    const response = await makeApiRequest(`/partners/get-all`);
    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_partnerActionErrors(responseDto.error));
      } else {
        dispatch(redux_getAllPartnerUsers(responseDto.data));
      }
  } catch (error) {
    dispatch(redux_partnerActionErrors((error as any)?.message || 'Error fetching partners',));
  }
};

export const createPartnerUser = (userData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_partnerActionStarts());
  try {
    const response = await makeApiRequest(`/partners/add`, {
      method: 'POST',
      body: JSON.stringify(userData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_partnerActionErrors(responseDto.error));
      } else {
        dispatch(redux_createPartnerUser(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_partnerActionErrors((error as any)?.message || 'Error creating partner',));
  }
};


export const updatePartnerUser = (id: string, userData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_partnerActionStarts());
  try {
    const response = await makeApiRequest(`/partners/update/${id}`, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_partnerActionErrors(responseDto.error));
      } else {
        dispatch(redux_updatePartnerUser(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_partnerActionErrors((error as any)?.message || 'Error updating partner',));
  }
};

export const deletePartnerUser = (id: string) => async (dispatch: Dispatch) => {
  dispatch(redux_partnerActionStarts());
  try {
    const response = await makeApiRequest(`/partners/delete/${id}`, {
      method: 'DELETE',
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_partnerActionErrors(responseDto.error));
      } 
  } catch (error) {
    dispatch(redux_partnerActionErrors((error as any)?.message || 'Error deleting partner',));
  }
};
